const VERSION = 'v0.10.1';

export default VERSION;



// WEBPACK FOOTER //
// ../gwi-ads/iab_728x90_leaderboard/src/config/version.js